<template>
  <section class="container-onboarding-content">
    <div class="wrapper-title">
      <h3>{{ t('onboarding_interpreted_chatroom') }}</h3>
      <OnboardingOptionsImage
        class="profile-selector fadeinOnboarding"
        :only-current-profile="isImageDisplayOnly"
        :input-image="form.callLogoImage"
        :background-color="form.callLogoBackgroundColor"
        :nickname-initial="nicknameInitial"
      />
      <h4 class="accent fadeinOnboarding">
        {{ title }}
      </h4>
      <h4 class="fadeinOnboarding">
        {{ t('onboarding_chatroom_is_ready') }}
      </h4>
    </div>
    <a class="dim bottom" @click="goToDashboard">{{
      t('onboarding_go_to_dashboard')
    }}</a>
  </section>
</template>

<script setup lang="ts">
import { computed, ref } from 'vue';
import { useI18n } from 'vue-i18n';
import { useRouter } from 'vue-router';

import OnboardingOptionsImage from '@/components/domains/self-service/onboarding/OnboardingOptionsImage.vue';
import { ISelfServiceOnboardingForm } from '@/types/components';
import { CREATE_CHAT_TYPES } from '@/utils/constants/chat';

const router = useRouter();
const { t } = useI18n();

const form = defineModel<ISelfServiceOnboardingForm>({
  required: true,
  default: () => ({}) as ISelfServiceOnboardingForm,
});

const isImageDisplayOnly = ref<boolean>(true); // 프로필 이미지 보기 전용 여부

// 통화방 제목
const title = computed<string>(() => {
  return CREATE_CHAT_TYPES.includes(form.value.callType)
    ? form.value.title
    : ({
        AUDIENCE: t('label_audience'),
        SINGLE: t('label_single'),
      }[form.value.callType] || '') + ` ${t('label_interpretation')}`;
});

// 닉네임 첫글자 반환
const nicknameInitial = computed(() => {
  return form.value.nickname.charAt(0);
});

// 대시보드로 이동
const goToDashboard = () => {
  router.push({ name: 'ss-dashboard' });
};
</script>

<style scoped>
.bottom {
  position: absolute;
  bottom: 6rem;
}
</style>
